import {
  fetchCountries,
  fetchFeatures,
  fetchOrder,
  fetchRecipient,
  fetchRecipientCountries,
  setDisplayPayerInformation,
  setFieldsValues,
  setFieldsValuesFromOrderTemplate,
  setLocale,
  setRecurringConfigurationId,
  setShouldDisablePayerInformationFields,
  setThemeSettings,
} from 'actions';
import { fetchSender } from 'actions/entities/sender';
import { EmbeddedRepository } from 'repositories/embedded/embedded';
import {
  getRecipient,
  getRecurringConfigurationIdFromMetadata,
  getSenderCountry,
} from 'selectors';
import { logger } from 'services/logger/logger';
import type { PayexThunkAction } from 'store/configureStore';

const removeNonWordCharactersFromCountry = (props: {
  sender_country?: string;
}) => (props.sender_country = props.sender_country?.replace(/[\W|\d]+/g, ''));

const prepareAmountValue = (amount: number | { [key: string]: number }) => {
  const amountIsObject = typeof amount === 'object';

  return {
    amount: amountIsObject
      ? Object.values(amount).reduce((acc, val) => acc + +val, 0)
      : amount,
    ...(amountIsObject && amount),
  };
};

export const bootstrap = (): PayexThunkAction => async (dispatch, getState) => {
  const embeddedProps = EmbeddedRepository.getProps();
  logger.log({ description: 'checkout parameters', parameters: embeddedProps });

  const {
    locale,
    token,
    displayPayerInformation = false,
    theme = {},
    recurring_configuration_id: recurringConfigIdFromProps,
    ...props
  } = embeddedProps;

  let recurringConfigurationId;

  dispatch(setThemeSettings(theme));
  dispatch(fetchFeatures());

  await dispatch(setLocale(locale));

  if (token) {
    await dispatch(fetchOrder({ token }));
    const state = getState();
    const recipient = getRecipient(state);
    const country = getSenderCountry(state);
    recurringConfigurationId = getRecurringConfigurationIdFromMetadata(state);
    await dispatch(fetchSender(country));

    if (recipient.id) {
      await dispatch(fetchRecipient(recipient.id));
      await dispatch(fetchRecipientCountries(recipient.id));
    }
  } else {
    removeNonWordCharactersFromCountry(props);
    await dispatch(fetchSender(props.sender_country));
    try {
      await dispatch(fetchRecipient(props.recipient));
      await dispatch(fetchRecipientCountries(props.recipient));
    } catch (_err) {
      // do nothing
    }
  }

  await dispatch(fetchCountries(locale));

  if (token) {
    await dispatch(setFieldsValuesFromOrderTemplate());
  }

  const fieldValues = {
    ...props,
    ...prepareAmountValue(props.amount),
  };
  await dispatch(setFieldsValues(fieldValues));

  dispatch(
    setShouldDisablePayerInformationFields({
      disablePayerInformationFields: !displayPayerInformation,
      payerInformationEditableFields: [],
    }),
  );
  dispatch(setDisplayPayerInformation(displayPayerInformation));
  dispatch(
    setRecurringConfigurationId(
      recurringConfigurationId || recurringConfigIdFromProps || null,
    ),
  );
};
